import { GetServerSideProps, InferGetServerSidePropsType } from 'next';
import HeadMetaTag from '@/components/metatags/HeadMetaTag2';
import React from 'react';
import CustomError from '@/features/errors';
import AppProvider from '@/context/AppProvider';
import { sanitizeQueryParams } from '@/helpers/sanitize';
import { fetchNavigation, fetchWebAPIServerDataHandler } from '@/lib/fetcher';
import RegionList from '@/features/cruise/region/RegionList/RegionList';

export const getServerSideProps: GetServerSideProps = async ({ query, req }) => {
  const { slug } = query;

  const queryParams = new URLSearchParams();

  if (typeof slug === 'string') {
    queryParams.set('slug', sanitizeQueryParams(slug, 100));
  }

  const path = `/cruise/region/${queryParams.get('slug')}`;
  const [navigation, pageProps] = await Promise.all([
    fetchNavigation(), // TODO: GET NAVIGATION FROM WEB-API AS WELL
    fetchWebAPIServerDataHandler(path, 'CRUISE REGION LIST', req),
  ]);
  const { props, notFound, redirect } = pageProps;
  if (notFound !== undefined) return { notFound: true };
  if (redirect !== undefined) return { redirect };
  if (props !== undefined) return { props: { ...props, navigation } };

  return {
    props: {
      data: { slug },
    },
  };
};

export default function PacotePage({ data, error, ...props }: InferGetServerSidePropsType<GetServerSideProps>) {
  if (error) {
    return <CustomError error={error} />;
  }
  const { meta } = data.page;
  return (
    <AppProvider navigation={...props.navigation}>
      <HeadMetaTag meta={meta} />
      <RegionList data={data} />
    </AppProvider>
  );
}
